<template>
  <div class="jump-box">
    <div class="jump">
      <img src="@/assets/images/loading.gif" alt=""/>
      <p style="font-size: 0.3rem">
        正在跳转到支付页面，请稍候~
      </p>
    </div>
  </div>
</template>
<script>
import {getChannelUserId} from '@/api/api'
import wayCodeUtils from '@/utils/wayCode'
import channelUserIdUtil from '@/utils/channelUserId'
import config from "@/config";

export default {
  components: {},
  mounted() {
    const that = this;
    const allQuery = Object.assign({}, this.searchToObject(), this.$route.query)
    // 获取用户ID信息
    getChannelUserId(allQuery).then(res => {
      // console.log(res)
      //设置channelUserId
      channelUserIdUtil.setChannelUserId(res);
      this.$router.push({name: wayCodeUtils.getPayWay().routeName, params: {qrcType: config.qrcType.QRC_STATIC.code}})
    }).catch(res => {
      that.$router.push({name: config.errorPageRouteName, params: {errInfo: res.msg}})
    });
  },
  methods: {
    searchToObject: function () {
      if (!window.location.search) {
        return {};
      }
      let pairs = window.location.search.substring(1).split("&"),
          result = {},
          pair,
          i;
      for (i in pairs) {
        if (pairs[i] === "") continue;
        pair = pairs[i].split("=");
        result[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1]);
      }
      return result;
    }
  }
}
</script>
<style scoped>
.jump-box {
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
